import { observer } from 'mobx-react-lite'
import { Modal, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { useCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { AssignmentFormFieldCell } from '../AssignmentFormFieldCell'
import type { DelegateExecutorModalStore } from '../../Stores/DelegateExecutorModalStore'

const { Text } = Typography

interface Props {
    store: DelegateExecutorModalStore
}

export const DelegateExecutorModal = observer(({ store }: Props) => {
    const { showSuccess, showError } = useNotification()
    const crudContext = useCrudResourceContext()

    return (
        <Modal
            title="Делегувати виконавця"
            open={store.open}
            onOk={() => store.delegate(
                { success: showSuccess, error: showError },
                () => crudContext?.actions?.reloadData?.(),
            )}
            onCancel={() => store.close()}
            confirmLoading={store.loading}
            okText="Делегувати"
            cancelText="Скасувати"
        >
            <div style={{ marginTop: 16 }}>
                <Text>Новий диспетчер <span style={{ color: 'red' }}>*</span>:</Text>
                <div style={{ marginTop: 8 }}>
                    <AssignmentFormFieldCell
                        key={`delegate-modal-${store.open}-${store.currentDispatcherUuid ?? ''}`}
                        fieldName="dispatcher"
                        fieldDef={{
                            type: 'select',
                            resource: 'Setting.User',
                            inputProps: {
                                filter: {
                                    filterRoles: { op: 'like', value: 'ROLE_DISPATCHER' },
                                    status: 'active',
                                    // Не пропонуємо вже призначеного диспетчера як ціль делегування.
                                    ...(store.currentDispatcherUuid
                                        ? { excludeCurrent: { field: 'uuid', op: '!=', value: store.currentDispatcherUuid } }
                                        : {}),
                                },
                                responseLabel: (item: any) => item?.fullName || item?.email || item?.uuid,
                                showSearch: true,
                                placeholder: 'Оберіть диспетчера...',
                            },
                        }}
                        initialValue={null}
                        initialIri={null}
                        onSave={(iri) => store.setDispatcherIri(iri ?? '')}
                        disabled={false}
                    />
                </div>
            </div>
        </Modal>
    )
})
